module.exports = __webpack_public_path__ + "img/arrow-left-black.ebb39135.svg";